/* eslint-disable react/jsx-closing-bracket-location */
import React, { createContext, useState, ReactNode, ReactElement } from 'react';
import {
  ICompetitionsContext,
  IIceHockeyCompetition,
  IPrefferencesContext
} from '../interfaces/interfaces';

export const PrefferencesContext = createContext({} as IPrefferencesContext);
export const CompetitionsContext = createContext({} as ICompetitionsContext);

export const PrefferencesProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [language, setLanguage] = useState<string>('');
  const [theme, setTheme] = useState<string>('light');
  const [parentHost, setParentHost] = useState<string>('');
  const [widgetWidth, setWidgetWidth] = useState<number>(0);

  return (
    <PrefferencesContext.Provider
      value={{
        language,
        setLanguage,
        theme,
        setTheme,
        parentHost,
        setParentHost,
        widgetWidth,
        setWidgetWidth
      }}>
      {children}
    </PrefferencesContext.Provider>
  );
};

export const CompetitionsProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [competitions, setCompetitions] = useState([] as IIceHockeyCompetition[]);
  const [matchDay, setMatchDay] = useState<number | null>(null);
  const [selectedCompetition, setSelectedCompetition] = useState({} as IIceHockeyCompetition);
  const [dropdownToggleUseEffect, setDropdownToggleUseEffect] = useState<boolean>(false);

  const competitionsState = {
    competitions,
    setCompetitions,
    selectedCompetition,
    setSelectedCompetition,
    matchDay,
    setMatchDay,
    dropdownToggleUseEffect,
    setDropdownToggleUseEffect
  };

  return (
    <CompetitionsContext.Provider value={competitionsState}>
      <PrefferencesProvider>{children}</PrefferencesProvider>
    </CompetitionsContext.Provider>
  );
};
